import React from 'react';
import {range} from 'lodash';

const SpringMarkSvg = ({monthsToFill, rgbColor}) => {
  const circleClass = (index) => {
    if (index == monthsToFill) return 'dot-pulse';
    if (index < monthsToFill) return 'dot-fill';
    return '';
  };

  const circleFill = index => (
    (index <= monthsToFill) ? rgbColor : 'none'
  );

  const renderSection = index => (
    <section className='spring-mark-border__month absolute z-10' key={`circle-${index}`}>
      <svg expanded='true'>
        <circle
          cx='50%'
          cy='50%'
          fill='none'
          r='35%'
          stroke={rgbColor}
          strokeWidth='10%'
        />

        <circle
          className={`inner-circle ${circleClass(index)}`}
          cx='50%'
          cy='50%'
          fill={circleFill(index)}
          r='35%'
          stroke={rgbColor}
        />
      </svg>
    </section>
  );

  return (
    <div className='spring-mark-svg-wrapper flex justify-center mx-auto relative'>
      <div className='spring-mark-border absolute'>
        {range(1, 13).map(index => (renderSection(index)))}
      </div>

      <svg
        className='spring-mark absolute'
        version='1.1'
        viewBox='0 0 23 33'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g
          fill='none'
          fillRule='evenodd'
          stroke='none'
          strokeWidth='1'
        >
          <g fill={rgbColor} transform='translate(-708.000000, -440.000000)'>
            <g transform='translate(689.000000, 425.000000)'>
              <path d='M19.6703346,37.6973 L26.5976423,37.6973 C26.5976423,39.6395692 28.5387192,41.1383 30.9221423,41.1383 C33.1720269,41.1383 34.8925269,40.1236462 34.8925269,38.1384538 C34.8925269,36.9473385 34.2307962,35.8444538 31.5385654,34.9621462 L27.9211038,33.8580692 C21.2143731,32.0505308 19.9350269,27.9466077 19.9350269,25.0779154 C19.9350269,19.6076077 24.6112577,15.9019154 30.6562577,15.9019154 C36.4806808,15.9019154 40.9363346,19.3870308 40.9363346,25.2996846 L34.0102192,25.2996846 C34.0102192,23.4897615 32.9073346,21.9457231 30.5251038,21.9457231 C28.3622577,21.9457231 26.9493731,23.2691846 26.9493731,24.9467615 C26.9493731,25.5643769 27.1270269,26.9319538 29.9504115,27.7260308 L33.1279115,28.6965692 C37.4512192,30.0212231 41.86395,32.2711077 41.86395,37.7855308 C41.86395,44.3158 36.2159885,47.0962615 30.6562577,47.0962615 C24.1701038,47.0962615 19.6703346,43.2999538 19.6703346,37.6973' />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default SpringMarkSvg;
